export default {
      id: "lely-bg-extended-point-usage",
      viewBox: "0 0 536 898",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#lely-bg-extended-point",
      toString: function () {
        return this.url;
      }
    }